
import { Outlet } from "react-router-dom";
import Footer from "../Footer";
import Navbar from "../Navbar";
import MobileBottomNav from "../MobileNav";
import ScrollToTop from "../ScrollToTop";
function PublicLayout() {
  return (
    <div className="bg-white dark:bg-[#0f0f0f] min-h-screen transition-all duration-300">
      <Navbar />
      <div className=" text-black dark:text-white">
        <Outlet />
      </div>
      <Footer />

      <MobileBottomNav /> 
      <ScrollToTop />
    </div>
  );
}

export default PublicLayout;
